import React, { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import "./PopupForm.css";

// ✅ Replace with your EmailJS credentials
const SERVICE_ID = "service_rfecciy";
const TEMPLATE_ID = "template_z8iyqab";
const PUBLIC_KEY = "-X18W1clM5HsqRDL-";

const PopupForm = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setShowPopup(true); // Show form on page load
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
        },
        PUBLIC_KEY
      )
      .then(() => {
        alert("✅ Your request has been sent successfully!");
        setFormData({ name: "", email: "", phone: "", subject: "" });
        setShowPopup(false);
      })
      .catch((err) => {
        console.error("EmailJS Error:", err);
        alert("❌ Failed to send request. Please try again later.");
      })
      .finally(() => setLoading(false));
  };

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-btn" onClick={() => setShowPopup(false)}>
          ×
        </button>
        <h2>Request a Callback</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Your Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <select
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          >
            <option value="">Select Your Service</option>
            <option value="Home Interiors">Home Interiors</option>
            <option value="Commercial Interiors">Commercial Interiors</option>
            <option value="Office Interiors">Office Interiors</option>
            <option value="Electrical & Lighting Solutions">
              Electrical & Lighting Solutions
            </option>
            <option value="Painting Works">Painting Works</option>
            <option value="Plumbing Works">Plumbing Works</option>
            <option value="Renovation Works">Renovation Works</option>
            <option value="Carpentry Works">Carpentry Works</option>
          </select>
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PopupForm;
